import { render, staticRenderFns } from "./myAccountPage.vue?vue&type=template&id=1d36b124&scoped=true&"
import script from "./myAccountPage.vue?vue&type=script&lang=ts&"
export * from "./myAccountPage.vue?vue&type=script&lang=ts&"
import style0 from "./myAccountPage.vue?vue&type=style&index=0&id=1d36b124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d36b124",
  null
  
)

export default component.exports